<template>
  <div class="flex flex-col bg-gray-900" style="height: calc(100vh - 65px)">
    <!-- Page header -->
    <div class="flex items-center gap-3 px-4 pt-4 pb-2">
      <span class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500">
        <span class="material-icons-round">article</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-100">Logs</h2>
        <p class="text-sm text-gray-400">Inspect system logs.</p>
      </div>
    </div>

    <!-- Terminal body -->
    <div class="flex-1 p-4 overflow-y-auto text-sm terminal-body terminal-font">
      <!-- Command line -->
      <div class="flex items-center justify-between mb-3">
        <div class="whitespace-nowrap">
          <span class="text-green-400">admin@taxiye</span><span class="text-gray-500">:</span><span class="text-blue-400">~/var/log</span><span class="text-gray-500">$</span>
          <span class="text-gray-200"> tail -n {{ perPage }} --page={{ currentPage }}<template v-if="level !== 'all'"> --level={{ level }}</template> taxiye.log</span>
        </div>
        <select
          v-model="level"
          @change="getLogs"
          class="px-2 py-1 ml-4 text-xs text-gray-200 bg-gray-800 border border-gray-600 rounded terminal-font focus:outline-none focus:border-green-500"
        >
          <option value="all">--all</option>
          <option value="info">--info</option>
          <option value="error">--error</option>
        </select>
      </div>

      <!-- Loading -->
      <div v-if="loading" class="text-gray-400">
        <span class="text-yellow-400">⣾</span> fetching logs<span class="dots"></span>
      </div>

      <!-- Log lines -->
      <template v-else-if="logs.data && logs.data.length">
        <div
          v-for="(log, index) in logs.data"
          :key="index"
          class="py-0.5 leading-relaxed whitespace-pre-wrap break-words border-b border-gray-800/60 hover:bg-gray-800/50"
        >
          <span class="text-gray-500 select-none">{{ lineNumber(index) }}</span>
          <span class="text-teal-400">[{{ log.timestamp }}]</span>
          <span :class="levelClass(log)" class="font-semibold uppercase">{{ logLevel(log) }}</span>
          <span class="text-gray-200"> {{ log.message }}</span>
        </div>
      </template>

      <!-- Empty -->
      <div v-else class="text-gray-400">
        <span class="text-red-400">✗</span> no logs found — 0 lines matched
      </div>
    </div>

    <!-- Pagination footer -->
    <div class="px-4 py-3 bg-gray-800 border-t border-gray-700">
      <pagination
        class="flex space-x-2"
        :currentPage="currentPage"
        :total="total"
        @goto="goToPage"
        @setPerPage="setPerPage"
        :perPage="perPage"
        :start="start"
        :end="end"
        :count="paginator.count"
      ></pagination>
    </div>
  </div>
</template>

<script>
// import _ from "lodash";
import PaginationMixin from "@/mixins/Pagination";
import Pagination from "@/components/Pagination";

export default {
  mixins: [PaginationMixin],
  data() {
    return {
      logs: [],
      loading: true,
      perPage: 30,
      level: "all",
      searchKey: ""
    };
  },
  created() {
    if (this.$route.query.page) {
      this.currentPage = this.$route.query.page;
    }
    this.getLogs();
  },
  components: {
    Pagination,
  },
  watch: {
    currentPage() {
      this.getLogs();
    },
    perPage() {
      this.currentPage === 1 ? this.getLogs() : (this.currentPage = 1);
    },
    selectedFilter() {
      this.getLogs();
    },
    range: {
      handler() {
        this.getLogs();
      },
      deep: true,
    },
    $route() {
      if (this.$route.query.status) {
        this.selectedFilter = this.$route.query.status;
      }
    },
  },
  methods: {
    lineNumber(index) {
      const line = (this.currentPage - 1) * this.perPage + index + 1;
      return String(line).padStart(4, " ");
    },
    logLevel(log) {
      return log.level || (this.level !== "all" ? this.level : "info");
    },
    levelClass(log) {
      const level = this.logLevel(log).toLowerCase();
      if (level === "error") return "text-red-400";
      if (level === "warn" || level === "warning") return "text-yellow-400";
      if (level === "debug") return "text-purple-400";
      return "text-green-400";
    },
    getLogs() {
      this.loading = true;
      var path =
        'logs?limit=' + this.perPage + "&page=" + this.currentPage;

      if (this.searchKey) {
        path += "&q=" + this.searchKey;
      }

      if (this.level && this.level != "all") {
        path += "&level=" + this.level;
      }
      this.$misc
        .get(path)
        .then(response => {
          this.logs = response.data;
          this.paginator = {
            nextPage: response.data.data.nextPage,
            count: response.data.data.count
          };
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })

    }
  }
};
</script>

<style scoped>
.terminal-font {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
}

.dots::after {
  content: "";
  animation: dots 1.2s steps(4, end) infinite;
}

@keyframes dots {
  0% { content: ""; }
  25% { content: "."; }
  50% { content: ".."; }
  75% { content: "..."; }
}

.terminal-body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.terminal-body::-webkit-scrollbar-track {
  background: #111827;
}

.terminal-body::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}
</style>
